import { render } from "./Modal.vue?vue&type=template&id=e80fcaf4&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=e80fcaf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e80fcaf4"

export default script